module.exports = __webpack_public_path__ + "img/envelope-32.e89ab8b3.svg";